export default __webpack_public_path__ + "static/media/logo_bookuj.432868cf.png";